import { render } from "./SuccessScreen.vue?vue&type=template&id=8f5215cc"
import script from "./SuccessScreen.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SuccessScreen.vue?vue&type=style&index=0&id=8f5215cc&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__